import BasicInformation from "./basicInformation";
export default BasicInformation;